import { render, staticRenderFns } from "./privacyAgreement.vue?vue&type=template&id=b712235e&scoped=true"
var script = {}
import style0 from "./privacyAgreement.vue?vue&type=style&index=0&id=b712235e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b712235e",
  null
  
)

export default component.exports